import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Box,
  Typography,
  IconButton
} from "@mui/material";
import CustomerSelectionDialog from "./CustomerSelectionDialog";
import NewCustomerForm from "./NewCustomerForm";
import { Close as CloseIcon } from "@mui/icons-material";
import PersonIcon from "@mui/icons-material/Person";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import "../../styles/InstantBookingButton.css";

const InstantBookingButton = ({ user }) => {
  const [open, setOpen] = useState(false);
  const [showNewCustomerForm, setShowNewCustomerForm] = useState(false);
  const [showCustomerSelection, setShowCustomerSelection] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setShowNewCustomerForm(false);
    setShowCustomerSelection(false);
  };

  const handleNewCustomer = () => {
    setOpen(false);
    setShowNewCustomerForm(true);
  };

  const handleExistingCustomer = () => {
    setOpen(false);
    setShowCustomerSelection(true);
  };

  if (user.role !== "Staff" && user.role !== "Admin") {
    return null;
  }

  return (
    <>
      <Button
        variant="contained"
        onClick={handleOpen}
        className="instant-booking-button"
      >
        Instant Booking
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: 2,
            minWidth: "300px"
          }
        }}
      >
        <DialogTitle className="dialog-title">
          <Typography
            variant="h6"
            component="div"
            className="dialog-title-text"
          >
            Select Customer Type
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          <Stack spacing={2} sx={{ my: 1 }}>
            <Button
              variant="contained"
              onClick={handleExistingCustomer}
              className="customer-selection-button"
              startIcon={<PersonIcon />}
            >
              Existing Customer
            </Button>
            <Button
              variant="contained"
              onClick={handleNewCustomer}
              className="new-customer-button"
              startIcon={<PersonAddIcon />}
            >
              New Customer
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>

      {showNewCustomerForm && (
        <NewCustomerForm open={showNewCustomerForm} onClose={handleClose} />
      )}
      <CustomerSelectionDialog
        open={showCustomerSelection}
        onClose={handleClose}
      />
    </>
  );
};

export default InstantBookingButton;
